export function formatNumber(value) {
  if (value == null) return '—';
  return new Intl.NumberFormat('en-US').format(value);
}

/** Daily/period averages — keep a fraction when the rounded count would be 0. */
export function formatAverage(value) {
  if (value == null || !Number.isFinite(value)) return '—';
  if (value === 0) return '0';
  const abs = Math.abs(value);
  const digits = abs < 0.1 ? 2 : abs < 10 ? 1 : 0;
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: digits,
  }).format(value);
}

export function formatCurrency(cents, currency = 'USD') {
  if (cents == null) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: String(currency).toUpperCase(),
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

export function formatDateTime(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}

export function formatDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString();
}
